import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BalanceListContainer from '../../containers/balance/BalanceListContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

const BalanceHoldList = () => {
  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_HOLD_LIST}>
      <BalanceListContainer pageType="hold" />
    </PageTemplate>
  );
};

export default BalanceHoldList;
